import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import TimeSlots from '../../../Shared/TimeSlots/TimeSlots';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, setTechnicianDay, setTechnicianSelectedTime, setSupplyType, reportDWH, setIsLoadingShoppingCart } from '../saleJetBlockSlice';
import { getCustomerAddresses, getTechnicianTimesAsync, enterInternetAddPaymentMode } from '../saleBlockAsyncThunk';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import likeIcon from '../../../Shared/TimeSlots/images/icon-24-like.svg';
import Image from 'app/Components/Shared/Image/image';
import PackageDetails from '../Partials/PackageDetails/PackageDetails';

const TechnicianPage = (props) => {
  useEffect(() => {
    props.setIsLoadingShoppingCart(false);
    gtag4({
      event: props.saleType == "cellular" ? 'cellular_Step11_TechnicianPage' :  `${props.saleType}_Step6_TechnicianPage`,
      step: props.saleType == "cellular" ? '11' : '6',
      action: 'TechnicianPage',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`
    });
    props.reportDWH({ actionType: 'Select Technician Date', status: 'Ongoing', messageText: 'Technician Date Page Displayed' });
  }, []);

  useExtendedEffect((runSideEffects) => {
    if (!runSideEffects()) {
      props.getTechnicianTimesAsync();
    }
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = props.isOccupiedTechnicianSlot ? 'אישור וסיום' : 'המשך לתשלום';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  const toggleLinkStyle = {
    color: 'var(--theme-primary, #9631ff)',
    fontSize: '16px',
    textAlign: 'center',
    textDecoration: 'underline',
    display: 'block',
    marginTop: '14px',
  };
  const supplyMethod = props.saleCatalog?.supplyMethods?.find((x) => x.name == 'Technician');
  //page params

  const firstTechnicianDayDisplay = props.technicianTimes?.[0]?.dayOfWeek
    ? `${props.technicianTimes[0].dayOfWeek} הקרוב`
    : props.firstTechnicianTimeDisplay;

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <PackageDetails/>
      <h1 className='sale-title'></h1>

      <h1 className='sale-title-big'>
        {props.isOccupiedTechnicianSlot ? (
          <span>הזמן שבחרת כבר לא זמין, איזה מועד אחר יתאים לך?</span>
        ) : (
          <span>
            נוכל לתאם התקנה כבר<br /> ביום {firstTechnicianDayDisplay}. מתאים?
          </span>
        )}
      </h1>

      {parseFloat(supplyMethod?.price) > 0 ? (
        <h3 className='sale-title-small-purple like-icon'><Image src={likeIcon} alt="like" className="icon" />עלות ביקור הטכנאי הינה ₪{supplyMethod?.price}</h3>
      ) : (
        <h3 className='sale-title-small-purple like-icon'><Image src={likeIcon} alt="like" className="icon" />ביקור טכנאי ללא עלות נוספת</h3>
      )}
    </div>
  );

  let currentPageView = (
    <div>
      <TimeSlots technicianTimes={props.technicianTimes} onSelectDay={handleSelectDay} onSelectHours={handleSelectHours} />
      {props.saleType == 'tv' && (
        <a href='#' style={toggleLinkStyle} onClick={() => goToDeliveryAddressPage()}>
          רוצה להתקין בעצמך ולתאם משלוח במקום?
        </a>
      )}
    </div>
  );

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );

  function handlePageContinue() {
    gtag4({
      event:  props.saleType == "cellular" ?  'cellular_Step11_TechnicianContinueButton' : `${props.saleType}_Step6_TechnicianContinueButton`,
      step: props.saleType == "cellular" ? '11' : '6',
      button: btnText,
      action: 'TechnicianContinueButton',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`
    });


    props.reportDWH({ actionType: 'Select Technician Date', status: 'Ongoing', messageText: 'Technician Date Page Button Clicked' });

    if (props.isOccupiedTechnicianSlot) {
      props.goToPage('createSaleInProcess');
      return;
    }

    // Fiber payment: new customer → new-design payment page (no BAN fetch); existing → BAN list or add-payment
    if (props.saleType === 'internet') {
      const isFullAuthenticated = Boolean(props._authentication?.loginData?.isFullAuthenticated);
      const isNewCustomer = props.flowType === 'newCustomer' && !isFullAuthenticated;

      if (isNewCustomer) {
        props.goToPage('internetExistingPaymentPage');
        return;
      }

      if (isFullAuthenticated) {
        props.getCustomerAddresses();
      } else {
        props.enterInternetAddPaymentMode();
      }
      return;
    }

    if (props.flowType == 'existsCustomer') {
      props.getCustomerAddresses();
    } else {
      props.goToPage('personalInfoPage');
    }
  }

  function handleSelectDay(data) {
    props.setTechnicianDay(data);
  }

  function handleSelectHours(data) {
    props.setTechnicianSelectedTime(data);
    props.reportDWH({ actionType: 'Select Technician Date', status: 'Ongoing', messageText: 'Technician Date Button Clicked' });
  }

  function goToDeliveryAddressPage() {
    props.setSupplyType('delivery');
    props.goToPage('deliveryAddressPage');
  }

  function handleSubmit(event) {
    event.preventDefault();
  }
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    offerName: state.saleJetBlock.offerName,
    technicianTimes: state.saleJetBlock.technician.technicianTimes,
    saleCatalog: state.saleJetBlock.saleCatalog,
    firstTechnicianTimeDisplay: state.saleJetBlock.technician.firstTechnicianTimeDisplay,
    isOccupiedTechnicianSlot: state.saleJetBlock.isOccupiedTechnicianSlot,

    //other states
    _authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  goToPage,
  setTechnicianDay,
  setTechnicianSelectedTime,
  setSupplyType,
  getCustomerAddresses,
  getTechnicianTimesAsync,
  enterInternetAddPaymentMode,
  reportDWH,
  setIsLoadingShoppingCart
};

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianPage);
